export function throwIfAlreadyLoaded(parentModule: any, moduleName: string) {
  if (parentModule) {
    throw new Error(
      `${moduleName} a déjà été chargé, Core module est seulement importé en App module`,
    );
  }
}
